// App.js
import React from 'react';
import './Landing.css';
import Header from './Header';
import Articles from './Articles';
import About from './About';
import Slider from './Slider';
import Plans from '../Plan/Plans'
import Contact from './Contact';
import GetApp from './GetApp';
import {Services} from '../Service/Services' ;
import {service} from '../../config/app';


function Landing({lang, account, onPlan}) {

  return (
    <div className="mainScreen">
      <Slider service={service} lang={lang} />
      <Plans service={service.id} lang={lang} onPlan={onPlan} />
      <Services  service={service.id} lang={lang} account={account} />
      <Articles service={service.id} lang={lang} />
      <Contact service={service} lang={lang} />
      { account?.connected ? <GetApp lang={lang} /> : null }
      <About lang={lang} />
    </div>
  );
}

export default Landing;

